// import  html2pdf  from 'html2pdf.js'
// import moment from 'moment'
// import React, { memo, useEffect, useRef, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
// import { useStyle } from './style'
// import { resetData } from '../../hooks/printPdf/pdfData'
// import { useLocation, useNavigate } from 'react-router-dom'
// import _ from 'lodash'
// import axios from 'axios'

// const TransferPrint = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const [gst , setGst] = useState([])
//     const [gData , setGData] = useState([])
//     const location = useLocation()
// const data = useSelector(state=> state.getData)
// const ref = useRef(null)
// console.log(location.pathname === '/warehouse/sales-or-issue' ? "hai" : "bye")
// const classes = useStyle()
// console.log(data,"checkdocnidtaa")
// const currentDate = new Date().toLocaleDateString('en-US', {
//     day: '2-digit',
//     month: 'long',
//     year: 'numeric',
//   });
//   const totalCgstAmnt = data.getData!==null && data.getData.tableData.reduce((acc, value) => acc + Number(value.cgstAmnt), 0);
//   const rowTotals = data.getData!==null && data.getData.tableData.map((value) => Number(value.cgstAmnt) + Number(value.cgstAmnt));
//   const totalNetAmnt = data.getData!==null && data.getData.tableData.reduce((acc, rowTotal) => acc + rowTotal.totalAmt, 0);

//   useEffect(()=>{
//     if(data.getData!==null && data.getData.tableData.length > 0){   
//         console.log(data.getData)
//         const groupedData = _.groupBy(data.getData.tableData,'cgstPerc')

//         const result = _.map(groupedData,(val,tax)=>({
//             cgstPerc : parseFloat(tax),
//             gstAmt : _.sumBy(val, item=> parseFloat(item.cgstAmnt))
//         }))
//         const groupedData1 = _.groupBy(data.getData.tableData, item=> `${item.pro_name}_${item.hsn}_${item.mrp}_${item.sale_rate}_${item.cgstPerc}_${item.pur_rate}`)
//                 const result2= _.map(groupedData1,(val,tax)=>({
//                     cgstPerc : val[0].cgstPerc,
//                     pro_code : val[0].pro_code,
//                     pro_name:val[0].pro_name,
//                     sale_rate : val[0].sale_rate,
//                     pur_rate: val[0].pur_rate,
//                     cgstAmnt : _.sumBy(val, item=> parseFloat(item.cgstAmnt)),
//                     hsn : val[0].hsn,
//                     qty : _.sumBy(val, item=> parseFloat(item.qty)),
//                     totalAmt: _.sumBy(val, item=> parseFloat(item.totalAmt)),
//                     disc1: val[0].disc1,
//                     gstAmt : _.sumBy(val, item=> parseFloat(item.cgstAmnt))
//                 }))
//                 console.log(result,'hi', data.getData.tableData[0])
//                 setGst(result)
//                 setGData(result2)

//     }
//     },[data])
// console.log(data,"datacheckl;kj;qlejdkj")
// useEffect(()=>{
// if(gst.length > 0){   
//     const input = ref.current;
//     const pdfOptions = {
//       margin: 10,
//       filename: `billNo_${data.getData.docno}_${moment().format("YYYY-MM-DD")}`, // Include the date in the filename
//       image: { type: "jpeg", quality: 0.98 },
//       html2canvas: { scale: 2 },
//       pagebreak: { mode: 'avoid-all' },
//       jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
//     };
    
// html2pdf().set(pdfOptions).from(input).save()

//   setTimeout(()=>{
//     // window.location.reload();
//     dispatch(resetData())
//     navigate(-1)
//   },3000)
// }
// },[gst])
// // console.log(data.getData.companyInfo.mode,"gDatagData");

//   return (
//     <div ref={ref} className='bg-white w-full' >
//    {data.getData !== null && 
//     <Grid sx={{border:'2px solid black'}}>
//     <Typography fontWeight={600} variant='h5' textAlign='center' sx={{backgroundColor:'rgb(203 213 225)', borderBottom:'1px solid', width:'100%', paddingBlock:1}}>{data.getData.title}</Typography>
//      <Grid className='pl-3 mb-3'>
//      <Typography className={classes.pdfTitle}>{data.getData.companyInfo.outlet_acname}</Typography>
//      <Typography className={classes.pdfTitle}>{data.getData.companyInfo.from_outlet_fullname}</Typography>
//          <Typography className={classes.pdfText}>{`${data.getData.companyInfo.from_outlet_add1} ${data.getData.companyInfo.from_outlet_add2}`}</Typography>
//          {/* <Typography className={classes.pdfText}>{data.getData.companyInfo.outlet_add2}</Typography> */}
//          <Typography className={classes.pdfText}>{data.getData.companyInfo.from_outlet_city_name} - {data.getData.companyInfo.from_outlet_pincode}</Typography>
//          <Typography className={classes.pdfText}>{data.getData.companyInfo.from_outlet_state_name
//          }</Typography>
//          {/* <Typography className={classes.pdfText}>{data.getData.companyInfo.outlet_pincode}</Typography> */}
//          <div className={classes.pdfFlex}>
//              <Typography className={classes.pdfText}>GST </Typography>
//              <Typography>- {data.getData.companyInfo.from_outlet_gstin}</Typography>
//          </div>
//          <div className={classes.pdfFlex}>
//              <Typography className={classes.pdfText}>Email </Typography>
//              <Typography>- {data.getData.companyInfo.from_outlet_email}</Typography>
//          </div>
//          <div className={classes.pdfFlex}>
//              <Typography className={classes.pdfText}>Mobile </Typography>
//              <Typography>- {data.getData.companyInfo.from_outlet_mobile}</Typography>
//          </div>
         
//      </Grid>
//     <Divider sx={{border:"1px solid #000"}} />
//     <Grid container sx={{marginBottom : 1}}>
//      <Grid item xs={12} md={8} className='pl-3  '>
//          <Typography className={classes.pdfTitle}>{data.getData.companyInfo.to_outlet_fullname}</Typography>
//          <Typography className={classes.pdfText}>{`${data.getData.companyInfo.to_outlet_add1} ${data.getData.companyInfo.to_outlet_add2}`}</Typography>
//          <Typography className={classes.pdfText}>{data.getData.companyInfo.to_outlet_city_name} - {data.getData.companyInfo.to_outlet_pincode}</Typography>
//          <Typography className={classes.pdfText}>{data.getData.companyInfo.to_outlet_state_name}</Typography>
         
//          <div className={classes.pdfFlex}>
//              <Typography className={classes.pdfText}>GST </Typography>
//              <Typography>- {data.getData.companyInfo.to_outlet_gstin}</Typography>
//          </div>
//          <div className={classes.pdfFlex}>
//              <Typography className={classes.pdfText}>Email : </Typography>
//              <Typography> {data.getData.companyInfo.to_outlet_email}</Typography>
//          </div>
//          <div className={classes.pdfFlex}>
//              <Typography className={classes.pdfText}>Mobile : </Typography>
//              <Typography> {data.getData.companyInfo.to_outlet_mobile}</Typography>
//          </div>
//          {/* <Typography className={classes.pdfUnderLine}>Shipping To</Typography>
//          <Typography className={classes.pdfText}>{data.getData.companyInfo.outlet_add1}</Typography>
//          <Typography className={classes.pdfText}>{data.getData.companyInfo.outlet_add2}</Typography> */}
//      </Grid>
//      <Grid item xs={12} md={4}>
//          <Table >
//              <TableBody>
//                  <TableRow className={classes.subRow}>
//                      <TableCell className={classes.tblCell}>Invoice No</TableCell>
//                      {/* <TableCell sx={{fontWeight:600}}>{data.getData.companyInfo.docno.replace("_", "/").replace("_", "-").replace("_", "/")}</TableCell> */}
//                      <TableCell sx={{fontWeight:600}}>{data.getData.companyInfo.docno}</TableCell>
//                  </TableRow>
//                  <TableRow className={classes.subRow}>
//                      <TableCell className={classes.tblCell}>Payment Mode</TableCell>
//                      <TableCell sx={{fontWeight:600}}>{data.getData.companyInfo.mode || "-"}</TableCell>
//                  </TableRow>   
//                  <TableRow className={classes.subRow}>
//                      <TableCell className={classes.tblCell}>Date</TableCell>
//                      <TableCell sx={{fontWeight:600}}>{currentDate}</TableCell>
//                  </TableRow>   
//                  <TableRow className={classes.subRow}>
//                      <TableCell className={classes.tblCell}>Total</TableCell>
//                      <TableCell sx={{fontWeight:600}}>{data.getData.TotalData.totalAmount}</TableCell>
//                  </TableRow>
//              </TableBody>
//          </Table>
//      </Grid>
//     </Grid>
//     <TableContainer className={classes.tblRoot}>
//      <Table>
//          <TableHead className={classes.tblHead}>
//              <TableRow >
//                  <TableCell rowSpan={2} >Sl No</TableCell>
//                  <TableCell rowSpan={2} >Product code</TableCell>
//                  <TableCell rowSpan={2}>Description of Goods</TableCell>
//                  {data.getData.tableData.some(val => val.hsn) && <TableCell rowSpan={2}>HSN Code</TableCell>}
//                  <TableCell rowSpan={2}>Rate</TableCell>
//                  <TableCell rowSpan={2}>Qty</TableCell>
//                  <TableCell rowSpan={2}>Discount</TableCell>
//                  {/* <TableCell rowSpan={2}>Taxable Value</TableCell> */}
//                {data.getData.companyInfo.mode === "Transfer" ? "" : 
//                <>
//                 <TableCell colSpan={2}>CGST</TableCell>
//                  <TableCell colSpan={2}>SGST</TableCell>
//                  </>
//                  }
//                  <TableCell rowSpan={2} >Amount</TableCell>
//              </TableRow>
//              {data.getData.companyInfo.mode === "Transfer" ? "" :
//              <TableRow >
//                  {/* <TableCell/> */}
//                  <TableCell>%</TableCell>
//                  <TableCell>Amt</TableCell>
//                  <TableCell>%</TableCell>
//                  <TableCell>Amt</TableCell>
//              </TableRow>}
//          </TableHead>
//          <TableBody>
//             {_.map(gData , (val,idx) => (
//                 <TableRow className={classes.tblRow} key={idx}>
//                     <TableCell>{idx + 1}</TableCell>
//                     <TableCell>{val.pro_code}</TableCell>

//                     <TableCell>{val.pro_name}</TableCell>
//                     {val.hsn && <TableCell>{val.hsn}</TableCell>}
//                     {/* {val.sale_rate && <TableCell>{val.sale_rate}</TableCell>}  */}
//                     {val.pur_rate && <TableCell>{val.pur_rate}</TableCell>} 
//                     <TableCell>{val.qty}</TableCell> 
//                     <TableCell>{val.disc1}</TableCell>
//                     {/* {val.pur_rate && <TableCell>{parseFloat(val.pur_rate * val.qty).toFixed(2)}</TableCell>}                    
//                     {val.sale_rate && <TableCell>{parseFloat(val.sale_rate * val.qty).toFixed(2)}</TableCell>}  */}
//                     {/* <TableCell> {parseFloat(val.cgstPerc).toFixed(2)/2}</TableCell>
//                     <TableCell> {parseFloat(val.cgstAmnt / 2).toFixed(2)}</TableCell>
//                     <TableCell> {parseFloat(val.cgstPerc).toFixed(2)/2}</TableCell>
//                     <TableCell> {parseFloat(val.cgstAmnt / 2).toFixed(2)}</TableCell>
//                     <TableCell>{parseFloat(Number(val.totalAmt) + Number(val.cgstAmnt)).toFixed(2)  }</TableCell> */}

// {data.getData.companyInfo.mode === "Transfer" ? "" :
//     <>        <TableCell>{!isNaN(parseFloat(val.cgstPerc)) ? (parseFloat(val.cgstPerc) / 2).toFixed(2) : '0.00'}</TableCell>
// <TableCell>{!isNaN(parseFloat(val.cgstAmnt)) ? (parseFloat(val.cgstAmnt) / 2).toFixed(2) : '0.00'}</TableCell>
// <TableCell>{!isNaN(parseFloat(val.cgstPerc)) ? (parseFloat(val.cgstPerc) / 2).toFixed(2) : '0.00'}</TableCell>
// <TableCell>{!isNaN(parseFloat(val.cgstAmnt)) ? (parseFloat(val.cgstAmnt) / 2).toFixed(2) : '0.00'}</TableCell> </>}
// <TableCell>
//   {!isNaN(Number(val.totalAmt)) && !isNaN(Number(val.cgstAmnt))
//     ? (Number(val.totalAmt) + Number(val.cgstAmnt)).toFixed(2)
//     : '0.00'}
// </TableCell>

               
//                 </TableRow>
//             ))}
//          </TableBody>
//      </Table>
//     </TableContainer>
//     <Grid className='flex justify-between p-2'>
//      <TableContainer className={classes.tblRoot} sx={{maxWidth: 'fit-content'}}>
//          {/* <Table sx={{borderLeft:'1px solid'}}>
//              <TableHead className={classes.tblHead}>
//                  <TableRow>
//                      <TableCell>Tax</TableCell>
//                      <TableCell>CGST Amt</TableCell>
//                      <TableCell>SGST Amt</TableCell>
//                      <TableCell>Total</TableCell>
//                  </TableRow>
//              </TableHead>
//              <TableBody>
//                 {_.map(gst , (value , idx) => (
//                     <TableRow className={classes.tblRow} key={idx}>
//                         <TableCell>{parseFloat(value.cgstPerc).toFixed(2)}</TableCell>
//                         <TableCell>{parseFloat(value.gstAmt  / 2).toFixed(2) }</TableCell>
//                         <TableCell>{parseFloat(value.gstAmt  / 2).toFixed(2) }</TableCell>
//                         <TableCell>{parseFloat(value.gstAmt).toFixed(2)}</TableCell>
//                     </TableRow>
//                 ))}
//                  <TableRow className={classes.tblRow}>
//                      <TableCell>Total</TableCell>
//                      <TableCell >{parseFloat(totalCgstAmnt / 2).toFixed(2) }</TableCell>
//                      <TableCell>{parseFloat(totalCgstAmnt / 2).toFixed(2)}</TableCell>
//                      <TableCell>{parseFloat(totalCgstAmnt).toFixed(2)  }</TableCell>
//                  </TableRow>
//              </TableBody>
//          </Table> */}
//      </TableContainer>
//      <Grid sx={{width:150, }}>
//          <div className={classes.pdfFlexBetween}>
//              <Typography className={classes.pdfTextTable}>Sub Total  </Typography>
//              <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.sub_total).toFixed(2)}</Typography>
//          </div>
//          <div className={classes.pdfFlexBetween}>
//              <Typography className={classes.pdfTextTable}>GST  </Typography>
//              <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.gst).toFixed(2)}</Typography>
//          </div>
//          {/* <div className={classes.pdfFlexBetween}>
//              <Typography className={classes.pdfTextTable}>Cess  </Typography>
//              <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.cess_amt).toFixed(2) }</Typography>
//          </div> */}
//          <div className={classes.pdfFlexBetween}>
//              <Typography className={classes.pdfTextTable}>Round Off  </Typography>
//              <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.roundOff).toFixed(2)}</Typography>
//          </div>
//          <div className={classes.pdfFlexBetween}>
//              <Typography className={classes.pdfTextTable}>Total  </Typography>
//              <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.totalAmount).toFixed(2)}</Typography>
//          </div>
         
//      </Grid>
//     </Grid>
//     <Divider sx={{border:"1px solid #000"}} />
//     <Grid className='flex justify-between'>
//          <Grid className='flex justify-between w-full items-center px-2'>
//              <Typography fontWeight={600} fontSize={16}>{data.getData.totalText} Rupees Only</Typography>
//              <Typography>Total</Typography>
//          </Grid>
//          <Grid  sx={{width:190, borderLeft:'1px solid ', padding:3 }}>
//              <Typography fontWeight={600} fontSize={16} textAlign='right'>{parseFloat(data.getData.TotalData.totalAmount).toFixed(2)}</Typography>
//          </Grid>
//     </Grid> 
//     <Divider sx={{border:"1px solid #000"}} />
//     <Grid className='pl-3 pt-1 mb-2'>
//      <Typography className={classes.pdfUnderLine}>Bank Details</Typography>
//      <div className={classes.pdfFlex}>
//          <Typography className={classes.pdfTextTable}>Account holders name :   </Typography>
//          <Typography className={classes.pdfTextTable}> {data.getData.companyInfo.outlet_acname}</Typography>
//      </div>
//      <div className={classes.pdfFlex}>
//          <Typography className={classes.pdfTextTable}>Bank :   </Typography>
//          <Typography className={classes.pdfTextTable}> {data.getData.companyInfo.outlet_bankname}</Typography>
//      </div>
//      <div className={classes.pdfFlex}>
//          <Typography className={classes.pdfTextTable}>Account no :   </Typography>
//          <Typography className={classes.pdfTextTable}> {data.getData.companyInfo.outlet_bankacno}</Typography>
//      </div>
//      <div className={classes.pdfFlex}>
//          <Typography className={classes.pdfTextTable}>IFSC :   </Typography>
//          <Typography className={classes.pdfTextTable}> {data.getData.companyInfo.outlet_ifsccode}</Typography>
//      </div>
//     </Grid>
//     <Divider sx={{border:"1px solid #000"}} />
//     <Grid className='flex justify-between px-3 mb-3' sx={{marginTop:2}}>
//      <Typography  sx={{fontSize:16,fontWeight:600}}>Received in good condition</Typography>
//      {/* <Typography>For <span  style={{fontSize:16,fontWeight:600}}>{data.getData.companyInfo.name}</span></Typography> */}
//     </Grid>
//     <Grid className='flex justify-between px-2 ' sx={{borderBottom:'1px solid',borderTop:'1px solid', marginTop:3}}>
//       <Grid>
//       <Typography sx={{ width:'100%'}} fontWeight={600}>Declaration :</Typography>
//      <Typography maxWidth={'60%'} sx={{paddingBlock:1}}>
//          We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct
//          </Typography>
//       </Grid>
//          <Typography textAlign='left' width='100%' maxWidth='40%' sx={{borderLeft:'1px solid', paddingBlock:1, paddingLeft:1}}>Authorised Signatory</Typography>
//     </Grid>
//     <Grid >
//      <Typography align='right' sx={{fontWeight:600, paddingBlock:1,paddingRight:3,paddingBlockEnd:2}}>This is computer generated Invoice</Typography>
//     </Grid>
//  </Grid>
//    }
// </div>
//   )
// }

// export default memo(TransferPrint)

import { Backdrop, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from '@mui/material';
import React, { Fragment, memo, useEffect, useRef, useState } from 'react';
import { Br, Cut, Line, Printer, Text, Row, render } from 'react-thermal-printer';
import { useStyle } from './style';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { resetData } from '../../hooks/printPdf/thermalData';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { setSnackbar } from '../../hooks/snackBar/reducers';

const TransferPrint = () => {
    const data = useSelector(state => state.getThermalData)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const classes = useStyle()
    const [text, setText] = useState("Baby Corn 5 Kg")
    const [flag, setFlag] = useState(false)
    const [gst,setGst] = useState([])
    const [gData, setGData] = useState([])

    console.log('vanthuden', data)
    
    useEffect(()=>{
        if(data.onPress){
            console.log('vanthuden', data)
          if(data.getThermalData!==null ){
            // printableDiv.classList.add('printPDF')
            // printableDiv.classList.remove('printPDF')
            console.log(data.getThermalData.companyInfo.docno, 'Enna ithu')
            const docBill = data.getThermalData.companyInfo.docno
            // console.log(docBill.replace("_", "/").replace("_", "-").replace("_", "/"))
            const groupedData = _.groupBy(data.getThermalData.tableData,'cgstPerc')
            const result = _.map(groupedData,(val,tax)=>({
                cgstPerc : parseFloat(tax),
                gstAmt : _.sumBy(val, item=> parseFloat(item.cgstAmnt))
            }))
            const groupData = _.groupBy(data.getThermalData.tableData, item => `${item.pro_name}_${item.hsn}_${item.mrp}_${item.sale_rate}_${item.cgstPerc}`)
            console.log(groupData)
            const getGroupData = _.map(groupData,(val,tax)=>({
                pro_name : val[0].pro_name,
                hsn : val[0].hsn,
                qty : _.sumBy(val, item=> parseFloat(item.qty)),
                sale_rate : val[0].sale_rate,
                mrp: val[0].mrp,
                totalAmt: _.sumBy(val, item=> parseFloat(item.totalAmt)),
                cgstAmnt : _.sumBy(val, item=> parseFloat(item.cgstAmnt)),
                cgstPerc: val[0].cgstPerc,
                disc1: val[0].disc1,
                // pur_rate: val[0].pur_rate,
            }))
            setGData(getGroupData)
            setGst(result)
            setFlag(true)
          }
        }
      
    },[data])
    useEffect(()=>{
      if(flag){
        window.print()
        dispatch(resetData())
        dispatch(setSnackbar(true,'success','Sales order processed successfully!'))
        navigate(-1)
        setFlag(false)
      }
    },[flag])
return(
<div>
{data.onPress && 
    <div style={{backgroundColor:'white', position : 'absolute', zIndex:1150, top:0,left : 0,  padding: 1}}>
<Printer type="epson" width={42}>
<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:16}} textTransform="uppercase">{data.getThermalData.companyInfo.company_fullname}</Typography>
<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:14}}>{data.getThermalData.companyInfo.outlet_acname}</Typography>
<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:14}}>From : {data.getThermalData.companyInfo.from_outlet_fullname}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>{data.getThermalData.companyInfo.from_outlet_add1}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>{data.getThermalData.companyInfo.from_outlet_add2}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>Mobile : +91{data.getThermalData.companyInfo.from_outlet_mobile}</Typography>
<Typography fontWeight={600} sx={{ color:'black', textAlign : 'center',  textWrap:'wrap',  fontSize:13}}>GSTIN - {data.getThermalData.companyInfo.from_outlet_gstin}</Typography>

<Typography sx={{color:'black', textAlign : 'center', fontWeight: 600, fontSize:14}}>To :  {data.getThermalData.companyInfo.to_outlet_fullname}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>{data.getThermalData.companyInfo.to_outlet_add1}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>{data.getThermalData.companyInfo.to_outlet_add2}</Typography>
<Typography sx={{ color:'black',textAlign : 'center',  textWrap:'wrap', fontSize:13}}>Mobile : +91{data.getThermalData.companyInfo.to_outlet_mobile}</Typography>
<Typography fontWeight={600} sx={{ color:'black', textAlign : 'center',  textWrap:'wrap',  fontSize:13}}>GSTIN - {data.getThermalData.companyInfo.to_outlet_gstin}</Typography>
{data.getThermalData.companyInfo.outlet_type_name==='OTHERS' && <Typography sx={{ color:'black',textAlign : 'center', fontWeight: 660,fontSize:13}}>Bill of Supply</Typography>}

<div style={{display : 'flex', justifyContent:'space-between', marginBlock: 1}}>
{/* <Typography sx={{color:'black', fontWeight:600, fontSize: 10}}>Bill No : {data.getThermalData.companyInfo.docno.replace("_", "/").replace("_", "-").replace("_", "/")}</Typography> */}
<Typography sx={{color:'black', fontWeight:600, fontSize: 10}}>Date : {moment(data.getThermalData.companyInfo.created_at).format('DD-MM-YYYY LT')}</Typography>
</div>
{/* <Text>--------------------------------------------</Text> */}
<TableContainer sx={{paddingInline:1}}>
    <Table>
        <TableBody>
        <TableRow>
                {/* <TableCell padding='checkbox' className={classes.headCell} sx={{minWidth: 30}}>S.no</TableCell> */}
                <TableCell className={classes.headCell} align='left' sx={{width:data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' ? 70 : 90, fontWeight: 600, fontSize:12}}>Item</TableCell>
                <TableCell className={classes.headCell} align='center' sx={{width:40, fontWeight: 600}}>HSN</TableCell>
                {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell} align='center' sx={{width:30, fontWeight: 600}}>Tax</TableCell>}
                <TableCell className={classes.headCell} align='center'  sx={{width:40, fontWeight: 600}}>Qty</TableCell>
                <TableCell className={classes.headCell} align='center'  sx={{width:45, fontWeight: 600}}>Rate</TableCell>
                <TableCell className={classes.headCell} align='right'  sx={{width:50, fontWeight: 600}}>Amt</TableCell>
            </TableRow>
                {_.map(gData,(val,idx)=>(
                    // val.pro_name.length > 6 ?
                    <TableRow key={idx} className={classes.tblRowCell}>
                    {/* <TableCell padding='checkbox' >{idx + 1}</TableCell> */}
                    <TableCell sx={{textWrap:'wrap'}}>{val.pro_name}</TableCell>
                    <TableCell align='left' >{val.hsn}</TableCell>
                    {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell align='center' >{val.cgstPerc} %</TableCell>}
                    <TableCell align='right'>{val.qty}</TableCell>
                    <TableCell align='right'>{data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' ? val.sale_rate : val.mrp}</TableCell>
                    <TableCell align='right'>{data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' ? parseFloat(val.totalAmt).toFixed(2) : parseFloat(parseFloat(val.totalAmt) + parseFloat(val.cgstAmnt)).toFixed(2)}</TableCell>
                    </TableRow> 
                ))}
          
<TableRow>
    <TableCell className={classes.headCell} colSpan={2}/>
    {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' &&  <TableCell className={classes.headCell} />}
    <TableCell className={classes.headCell} colSpan={2} align='left'  sx={{ color:'black', fontSize : 12}}>Total </TableCell>
    <TableCell className={classes.headCell} colSpan={2}  align='right' sx={{fontWeight : 600, color:'black', fontSize : 17}}>{data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' ? parseFloat(data.getThermalData.TotalData.sub_total).toFixed(2) : parseFloat(data.getThermalData.TotalData.sub_total + data.getThermalData.TotalData.gst ).toFixed(2)}</TableCell>
</TableRow>
<TableRow className={classes.tblRowCell}>
    <TableCell sx={{fontWeight : 600, color:'black', fontSize : 17}}>Tot Qty</TableCell>
    <TableCell sx={{textAlign:'left', color:'black'}} colSpan={data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' ? 1 : 3}>{parseFloat(data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + currentValue.qty, 0)).toFixed(2)}</TableCell>
    {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell} sx={{fontWeight : 600, color:'black', fontSize : 17}} colSpan={3}>Total Tax Amt</TableCell>}
    {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell} align='right' sx={{ color:'black', }} >{parseFloat(data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0)).toFixed(2)}</TableCell>}
</TableRow>

 {/* {_.map(gData,(val,idx)=>(
                    // val.pro_name.length > 6 ?
                    <TableRow key={idx}  className={classes.tblSubCell}>
                    <TableCell className={classes.headCell}/>
                    {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell}/>}
                    <TableCell className={classes.headCell} colSpan={2} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Discount Amount</TableCell>
                    <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{parseFloat(val.disc1 ).toFixed(2)}</TableCell>
                </TableRow>
                ))} */}
<TableRow  className={classes.tblSubCell}>
    <TableCell className={classes.headCell}/>
    {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell}/>}
    <TableCell className={classes.headCell} colSpan={2} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Grand Total</TableCell>
    {/* <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{parseFloat(data.getThermalData.TotalData.sub_total + data.getThermalData.TotalData.gst - data.getThermalData.companyInfo.discount_amount).toFixed(2)}</TableCell> */}
    <TableCell 
  className={classes.headCell} 
  colSpan={2} 
  align='right' 
  sx={{ fontWeight: 600, color: 'black', fontSize: 15 }}
>
{parseFloat(data.getThermalData.TotalData.totalAmount).toFixed(2)}
  {/* {Math.round(
    parseFloat(data.getThermalData.TotalData.sub_total) + 
    parseFloat(data.getThermalData.TotalData.gst) - 
    parseFloat(data.getThermalData.companyInfo.discount_amount)
  )} */}
</TableCell>


</TableRow>
{data.getThermalData.TotalData.returnAmnt!=="" && data.getThermalData.TotalData.returnAmnt!=='0.00' && data.getThermalData.TotalData.returnAmnt > 0 &&
    <TableRow  className={classes.tblSubCell}>
    <TableCell className={classes.headCell}/>
    {data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' && <TableCell className={classes.headCell}/>}
    <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Sales Return Amt</TableCell>
    <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{parseFloat(data.getThermalData.TotalData.returnAmnt).toFixed(2)}</TableCell>
</TableRow>}

{/* {data.getThermalData.redeemedValue != 0 && 
    <TableRow>
  <TableCell className={classes.headCell}/>
    <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Redeemed Amount</TableCell>
    <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{Math.round(data.getThermalData.redeemedValue).toFixed(2)}</TableCell>
</TableRow>
}
{data.getThermalData.lessAmount !== 0 &&
    <TableRow>
  <TableCell className={classes.headCell}/>
    <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Less Amount</TableCell>
    <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{parseFloat(data.getThermalData.lessAmount).toFixed(2)}</TableCell>
</TableRow>
}
{data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' &&
<TableRow>
  <TableCell className={classes.headCell}/>
    <TableCell className={classes.headCell} colSpan={3} align='left' sx={{ color:'black', fontSize : 14, fontWeight: 600}}>Amount Received</TableCell>
    <TableCell className={classes.headCell} colSpan={2} align='right' sx={{fontWeight : 600, color:'black', fontSize : 15}}>{Math.round(data.getThermalData.TotalData.totalAmount - data.getThermalData.companyInfo.discount_amount ).toFixed(2)}</TableCell> 

</TableRow>} */}

        </TableBody>
  
    </Table>
</TableContainer>

{data.getThermalData.companyInfo.outlet_type_name!=='OTHERS' &&
<TableContainer sx={{padding:1, color: 'black',}}>
    <Table>
        <TableHead >
           <TableRow >
           <TableCell className={classes.headCell}>Tax %</TableCell>
            <TableCell align='center'sx={{color:'black'}} className={classes.headCell}>CGST</TableCell>
            <TableCell align='center'sx={{color:'black'}} className={classes.headCell}>SGST</TableCell>
            <TableCell align='right'sx={{color:'black'}} className={classes.headCell}>Total</TableCell>
           </TableRow>
        </TableHead>
        <TableBody>
        {_.map(gst,(val,idx)=>(
            <TableRow className={classes.tblRowCell} key={idx}>
                <TableCell sx={{color:'black'}}>{parseFloat(val.cgstPerc).toFixed(2)}</TableCell>
                <TableCell sx={{color:'black'}} align='right'>{parseFloat(val.gstAmt / 2).toFixed(2)}</TableCell>
                <TableCell sx={{color:'black'}}align='right'>{parseFloat(val.gstAmt / 2).toFixed(2)}</TableCell>
                <TableCell sx={{color:'black'}}align='right'>{parseFloat(val.gstAmt).toFixed(2)}</TableCell>
            </TableRow>
        ))}
        <TableRow className={classes.tblSubCell}>
            <TableCell className={classes.headCell}>Total</TableCell>
            <TableCell align='right' className={classes.headCell}>{parseFloat((data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0) / 2)).toFixed(2)}</TableCell>
            <TableCell align='right' className={classes.headCell}>{parseFloat((data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0) / 2)).toFixed(2)}</TableCell>
            <TableCell align='right' className={classes.headCell}>{parseFloat(data.getThermalData.tableData.reduce((accumulator, currentValue) =>accumulator + Number(currentValue.cgstAmnt), 0)).toFixed(2)}</TableCell>
        </TableRow>
        </TableBody>
    </Table>
</TableContainer>
}
{data.getThermalData.companyInfo.outlet_type_name=='OTHERS' && <Divider sx={{ backgroundColor:'black', margin:1}}/> }
<Fragment>
{data.getThermalData.companyInfo.outlet_type_name=='OTHERS' && <Typography fontWeight={600} width={300} align='center' flexWrap='wrap' sx={{color:'black'}}>Composition Dealer: Not eligible to collect tax on supplies</Typography> }
<Typography  fontWeight={600} fontSize={12} marginLeft={2} sx={{color:'black'}}>Terms and Condition:</Typography>
<Typography  fontWeight={600} fontSize={12} marginLeft={2} sx={{color:'black'}}>*Goods received in good condition.</Typography>
<Typography  fontWeight={600} fontSize={12} marginLeft={2} sx={{color:'black'}}>*No exchange and No Return</Typography>
</Fragment>

<Typography textAlign='center'fontWeight={600} sx={{color:'black', fontSize: 13}}>Order Online: www.buygirlush.com</Typography>
<Typography textAlign='center'fontWeight={600} sx={{ color:'black',fontSize: 13}}>***  THANK YOU! VISIT AGAIN ***</Typography>
<Cut />

</Printer>
</div>}
</div>
)
}

export default memo(TransferPrint)